import AppGalleryIcon from '../../../assets/img/icons/mobileStores/AppGalleryIcon.svg';
import AppGalleryText from '../../../assets/img/icons/mobileStores/AppGalleryText.svg';
import AppStoreText from '../../../assets/img/icons/mobileStores/AppStoreText.svg';
import AppStoreWhiteIcon from '../../../assets/img/icons/mobileStores/AppStoreWhiteIcon.svg';
import GooglePlayIcon from '../../../assets/img/icons/mobileStores/GooglePlayIcon.svg';
import GooglePlayText from '../../../assets/img/icons/mobileStores/GooglePlayText.svg';
import RuStoreIcon from '../../../assets/img/icons/mobileStores/RuStoreIcon.svg';
import RuStoreText from '../../../assets/img/icons/mobileStores/RuStoreText.svg';

import { EStoreName } from './index';

interface IStoreData {
    link: string,
    title: string,
    store: {
        icon: 'AppStoreIcon' | 'GooglePlayIcon' | 'AppGalleryIcon'| 'RuStoreIcon',
        text: string,
    },
    storeType: 'AppStore' | 'GooglePlay' | 'AppGallery'| 'RuStore',
}

type TData = {
    [key in EStoreName]: IStoreData;
};

export const storeData: TData = {
    AppStore: {
        link: 'https://apps.apple.com/ru/app/dom-ru-agent/id799358248?mt8',
        title: 'AppStore',
        store: {
            icon: AppStoreWhiteIcon,
            text: AppStoreText,
        },
        storeType: 'AppStore',
    },
    GooglePlay: {
        link: 'https://play.google.com/store/apps/details?id=com.ertelecom.agent&hl=ru',
        title: 'GooglePlay',
        store: {
            icon: GooglePlayIcon,
            text: GooglePlayText,
        },
        storeType: 'GooglePlay',
    },
    AppGallery: {
        link: 'https://appgallery.huawei.com/app/C101960911',
        title: 'HuaweiAppGallery',
        store: {
            icon: AppGalleryIcon,
            text: AppGalleryText,
        },
        storeType: 'AppGallery',
    },
    MovixAppStore: {
        link: 'https://apps.apple.com/ru/app/dom-ru-tv/id825552263?mt=8&ign-mpt=uo%3D4',
        title: 'MovixAppStore',
        store: {
            icon: AppStoreWhiteIcon,
            text: AppStoreText,
        },
        storeType: 'AppStore',
    },
    MovixGooglePlay: {
        link: 'https://play.google.com/store/apps/details?id=com.ertelecom.domrutv',
        title: 'MovixGooglePlay',
        store: {
            icon: GooglePlayIcon,
            text: GooglePlayText,
        },
        storeType: 'GooglePlay',
    },
    SmartAppStore: {
        link: 'https://apps.apple.com/ru/app/%D1%83%D0%BC%D0%BD%D1%8B%D0%B9-%D0%B4%D0%BE%D0%BC-ru/id1373157818',
        title: 'SmartAppStore',
        store: {
            icon: AppStoreWhiteIcon,
            text: AppStoreText,
        },
        storeType: 'AppStore',
    },
    SmartGooglePlay: {
        link: 'https://play.google.com/store/apps/details?id=com.ertelecom.smarthome',
        title: 'SmartGooglePlay',
        store: {
            icon: GooglePlayIcon,
            text: GooglePlayText,
        },
        storeType: 'GooglePlay',
    },
    RuStore: {
        link: 'https://apps.rustore.ru/app/com.ertelecom.agent',
        title: 'RuStore',
        store: {
            icon: RuStoreIcon,
            text: RuStoreText,
        },
        storeType: 'RuStore',
    },
};
